import { render, staticRenderFns } from "./distributionRealtime2.vue?vue&type=template&id=78700cf2&scoped=true&"
import script from "./distributionRealtime2.vue?vue&type=script&lang=js&"
export * from "./distributionRealtime2.vue?vue&type=script&lang=js&"
import style0 from "./distributionRealtime2.vue?vue&type=style&index=0&id=78700cf2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78700cf2",
  null
  
)

export default component.exports